import { JobPostingServiceApi } from 'mnvm-mypage-app-ts-if'
import { config } from './api-config'

export const jobPostingServiceApi = new JobPostingServiceApi(config)

// API client function for updating memo
export const updateJobPostingMemo = async (
  jobPostingId: string,
  mpOrderMemo: string
): Promise<string> => {
  let normalized = mpOrderMemo
  try {
    const res =
      await jobPostingServiceApi.jobPostingServiceUpdateJobPostingMemo({
        jobPostingId,
        body: {
          mpOrderMemo
        }
      })
    normalized = (res as any)?.mpOrderMemo ?? mpOrderMemo
  } catch (error) {
    console.error('Failed to update memo:', error)
    throw error
  }
  return normalized
}
